/* =========================================================
   MANEWAY MOTION
   Tags elements in the mw-* sections for scroll-reveal and
   plays their entrance when they scroll into view.
   Styles: assets/mw-motion.css.

   The hero animates with CSS on load, and the collections
   section has its own reveal, so neither is listed here.
========================================================= */

(function () {
  'use strict';

  var root = document.documentElement;

  if (!root.classList.contains('mw-motion')) return;

  /*
    Per section type: [element suffix, reveal type, stagger step (s), float?]
    Each row starts a little after the previous one; elements matched
    by the same row are staggered by the step.
  */
  var SECTIONS = {
    story: [
      ['__image-wrap', 'zoom'],
      ['__eyebrow', 'up'],
      ['__heading', 'up'],
      ['__body', 'up'],
      ['__button', 'up'],
      ['__art', 'fade', 0.15, true]
    ],
    'best-sellers': [
      ['__eyebrow', 'up'],
      ['__heading', 'up'],
      ['__description', 'up'],
      ['__controls', 'fade'],
      ['.splide__slide', 'up', 0.09],
      ['__button-wrap', 'up']
    ],
    features: [
      ['__eyebrow', 'up'],
      ['__heading', 'up'],
      ['__image-wrap', 'zoom'],
      ['__badge', 'pop', 0, true],
      ['__card', 'up', 0.14]
    ],
    category: [
      ['__shape', 'fade', 0, true],
      ['__eyebrow', 'up'],
      ['__title', 'up'],
      ['__card', 'up', 0.1]
    ],
    steps: [
      ['__horse-shape', 'fade', 0, true],
      ['__eyebrow', 'up'],
      ['__heading', 'up'],
      ['__subheading', 'up'],
      ['__line', 'draw'],
      ['__step', 'up', 0.22]
    ],
    testimonials: [
      ['__shape', 'fade', 0, true],
      ['__eyebrow', 'up'],
      ['__heading', 'up'],
      ['__visual', 'zoom'],
      ['__card', 'up'],
      ['__controls', 'fade']
    ],
    faq: [
      ['__shape', 'fade', 0, true],
      ['__eyebrow', 'up'],
      ['__title', 'up'],
      ['__item', 'up', 0.07]
    ]
  };

  var ROW_STEP = 0.12;
  var MAX_ROW_DELAY = 0.36;
  var MAX_STAGGER_ITEMS = 6;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      // Reveal the whole row together (keeps stagger, and slides that are
      // off to the side of a slider are ready before they're swiped in).
      (entry.target.mwGroup || [entry.target]).forEach(function (el) {
        observer.unobserve(el);
        if (!el.classList.contains('mw-done')) el.classList.add('mw-in');
      });
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  function onAnimationEnd(event) {
    var el = event.currentTarget;
    if (event.target !== el) return;
    el.removeEventListener('animationend', onAnimationEnd);
    el.classList.remove('mw-in');
    el.classList.add('mw-done');
  }

  function findSectionRoots() {
    var found = [];

    // Section ids can contain "__" (e.g. template--123__maneway_story_ab12),
    // so build each root class from the Shopify section wrapper's id.
    document.querySelectorAll('.shopify-section[id^="shopify-section-"]').forEach(function (wrapper) {
      var sectionId = wrapper.id.replace('shopify-section-', '');

      Object.keys(SECTIONS).forEach(function (type) {
        var rootClass = 'mw-' + type + '-' + sectionId;
        var el = wrapper.getElementsByClassName(rootClass)[0];

        if (el) found.push({ el: el, rootClass: rootClass, type: type });
      });
    });

    return found;
  }

  function tagSection(section) {
    if (section.el.hasAttribute('data-mw-motion')) return;
    section.el.setAttribute('data-mw-motion', '');

    var rowDelay = 0;

    SECTIONS[section.type].forEach(function (row) {
      var suffix = row[0];
      var reveal = row[1];
      var stagger = row[2] || 0;
      var float = row[3];

      var elements = suffix.charAt(0) === '.'
        ? section.el.querySelectorAll(suffix)
        : section.el.getElementsByClassName(section.rootClass + suffix);

      if (!elements.length) return;

      var group = Array.prototype.slice.call(elements).filter(function (el) {
        return !el.hasAttribute('data-mw-r');
      });

      group.forEach(function (el, index) {
        el.mwGroup = group;

        var delay = rowDelay + stagger * Math.min(index, MAX_STAGGER_ITEMS);

        el.setAttribute('data-mw-r', reveal);
        el.style.setProperty('--mw-d', delay.toFixed(2) + 's');

        if (float) el.setAttribute('data-mw-float', '');

        el.addEventListener('animationend', onAnimationEnd);
        observer.observe(el);
      });

      rowDelay = Math.min(rowDelay + ROW_STEP, MAX_ROW_DELAY);
    });
  }

  function init() {
    findSectionRoots().forEach(tagSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
